import styled from "styled-components";

const Wrapper = styled.footer`
    display : flex;
    justify-content : space-between;
    align-items : center;
    padding : 10px 6%;
    font-weight : 300;
    border-top : solid thin #ccc;
    .logo{
        height : 42px;
    }
    nav{
        border-bottom : solid thin #ccc;
        display : flex;
        justify-content : space-between;
        align-items : center;
        ul{
            padding : 0;
            display : flex;
            list-style : none;
            li{
                padding : 5px;
            }
            &.social-links{
                li{
                    a{
                        background : #000;
                        border-radius : 30px;
                        display : inline-block;
                        height : 32px;
                        width : 32px;
                        text-align : center;
                        line-height : 32px;
                    }
                }
            }
        }
    }
    .info{
        text-align : right;
        
        a,a:link{
            color : #000;
            text-decoration : none;
            display : inline-block;
            padding : 20px 0;
            font-size : 14px;
            &:first-child{
                margin-right : 20px;
            }
            &:hover{
                color : #2251ff;
                text-decoration : underline;
            }
        }
        div{
            border-bottom : solid thin #ccc;
            display : inline-block;
            // gap : 20px;
            width : auto;
        }
        p{
            
            margin : 0;
            padding : 20px 0;
        }
    }
`

export default Wrapper